import { render, staticRenderFns } from "./TransparentPendant.vue?vue&type=template&id=3d5c2cd6&scoped=true&"
import script from "./TransparentPendant.vue?vue&type=script&lang=js&"
export * from "./TransparentPendant.vue?vue&type=script&lang=js&"
import style0 from "./TransparentPendant.vue?vue&type=style&index=0&id=3d5c2cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5c2cd6",
  null
  
)

component.options.__file = "TransparentPendant.vue"
export default component.exports